const addNewItem = (variantId, qty) => {
    const data = {
      id: variantId,
      quantity: qty
    };
  
    const cartContents = fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .catch((error) => {
        console.error('Error:', error);
      });
  
    return cartContents;
  };

//create Custom element for product tile
class ProductUpsell extends HTMLElement {
    //initialize element
    constructor() { 
        super();
        this.sliderContainer = this.querySelectorAll("[data-upsell-items]");
        this.addToCartBtns = this.querySelectorAll("[data-add-to-cart]");
        this.variantUpsellsOptions = this.querySelectorAll("[data-variant-select] [data-option]");
    }

    //called when element is added to DOM
    connectedCallback() {
        //add event listeners
        this.addToCartBtns.forEach((btn) => {   
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                const productId = btn.getAttribute("data-add-to-cart");
                 this.addVariant(productId, 1);
            }
        )});

        this.variantUpsellsOptions.forEach((btn) => {   
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                const parent = btn.closest("[data-variant-select]")
                const productId = btn.dataset.option;
                const price = btn.dataset.variantPrice
                parent.querySelectorAll("[data-option]").forEach((item) => item.classList.remove('active'))
                const priceContainer = parent.querySelector('[data-price]')
                if(priceContainer){
                  priceContainer.innerHTML = "+$" + (price/100)
                }
                const upsellImage = parent.querySelector("[data-upsell-image]");
                if(upsellImage){
                  console.log(btn.dataset.image)
                  upsellImage.src = btn.dataset.image
                }
                const addToCart = parent.querySelector('[data-add-to-cart]');
                addToCart.dataset.addToCart = productId
                btn.classList.add('active')
            }
        )});
    }
    addVariant(variantId, qty) {
        addNewItem(variantId, qty).then((data) => {
            if(data){
                this.updateVariantContainer(data.variant_id);
            }
        })
    }
    updateVariantContainer(variantID) {
        const btn = this.querySelector(`[data-add-to-cart="${variantID}"]`);
        if("multiVariant" in btn.dataset ){
           const parent = btn.closest("[data-variant-select]")
           const option = parent.querySelector(`[data-option="${variantID}"]`);
           const text = option.querySelector('[data-inner-text]');
           // if(text){
           //   text.innerHTML = "";
           // }
           option.classList.add('added');
          const icon = option.querySelector('[data-icon]')
          icon.classList.remove('hidden')
        }else{
           btn.querySelector("[data-text]").innerHTML = "Added";
            btn.classList.add("active");
        }
       
        ajaxCart.load();
        //document.querySelector('#cart-icon-bubble').click();

    }
    //called when element is removed from DOM
    disconnectedCallback() {}
    //called when element is moved to new DOM
    adoptedCallback() {}
    //called when element attributes are changed
    attributeChangedCallback() {}

}       
//register custom element   
customElements.define('product-upsell', ProductUpsell);